$(function(){
	$(window).on('load scroll resize', function(){
        $('.item_block').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            var wh5 = $(window).height() / 5;
            // if (scroll > position - windowHeight + 200){
            if (scroll > position - windowHeight + wh5){
              $(this).addClass('is-active');
            }
        });

        if ($(window).scrollTop() > 0){
            $('.fixarea').addClass('is-fixed');
        } else {
            $('.fixarea').removeClass('is-fixed');
        }
    });

    $('.js-slider-noml:not(.is-left)').slick({
        dots: true,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
    })
    .on("afterChange", function(event, slick, currentSlide) {
        switch (currentSlide){
            case 0:
                $(this).slick("slickSetOption", "autoplaySpeed", 3000);
                break;
            case 2:
                $(this).slick("slickSetOption", "autoplaySpeed", 3000);
                break;
            default:
                $(this).slick("slickSetOption", "autoplaySpeed", 3000);
                break;
        }
    });
});
